import React from 'react';

const DownloadContext = React.createContext({});

export const DownloadProvider = DownloadContext.Provider;
export default DownloadContext;
